//NOTE: This library will eventually be extracted to Embercom Core https://github.com/intercom/embercom-core
let createObjectURL = window.URL && window.URL.createObjectURL.bind(window.URL) || window.webkitURL && window.webkitURL.createObjectURL.bind(window.webkitURL) || window.createObjectURL;
let BlobFile = {};
BlobFile.createUrl = function (file) {
  return file ? createObjectURL(file) : '';
};
BlobFile.createImage = function (file) {
  let img = new Image();
  img.src = BlobFile.createUrl(file);
  return img;
};
export default BlobFile;